module.exports = __webpack_public_path__ + "static/img/company-component-cove-10-3.12cb235c.jpg";